import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  Grid,
  RadioGroup,
  FormControl,
} from "@mui/material";
import React from "react";

const Comp13PDF = ({
    formData,
}) => {
    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5 ,border: '1px solid #ccc', borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box sx={{ mt: 0.5, mb: 1 }}>
        <Typography>SDGs 子ども・ユースフェア出展者　マイページ情報</Typography>
        <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
        <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
        <Typography variant="body1">部署: {formData?.department}</Typography>
        <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
        <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
        <Typography variant="body1">住所: {formData?.address}</Typography>
        <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
        <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
    </Box>
    <Box>
        <Typography variant="h6">ブース平面図</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Grid container spacing={2}>
            <Grid size={6}><TextField fullWidth label="氏名" name="user_13_name" value={formData?.user_13_name} /></Grid>
            <Grid size={6}><TextField fullWidth label="部署" name="user_13_department" value={formData?.user_13_department} /></Grid>
            <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_13_phone" value={formData?.user_13_phone} /></Grid>
            <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_13_tel" value={formData?.user_13_tel} /></Grid>
            </Grid>
            <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>
            
            <Typography variant="h6">備考欄</Typography>
            <Typography color="error">※ブース平面図について補足事項等がある場合はコチラにご入力ください。</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {formData?.alfa_text}
                        </Typography>
        </Box>
        )}
    </Box>
    </Container>
  );
};

export default Comp13PDF;
